export default {
  campuses:[],
  rentcarAreas: []
};
